import { React, useState } from 'react';
import Hardware from './Hardware';
import ErrorAlert from '../../components/Alert/ErrorAlert';

export default function ConvertFiles() {
  const [error, setError] = useState(null);

  const handleErrorClose = () => {
    setError(null);
  };

  return (
    <>
      {error && <ErrorAlert message={error} onClose={handleErrorClose} />}
      <div className="HardwarePage scene">
        <div className="page">
          <Hardware setError={setError} />
        </div>
      </div>
    </>
  );
}
